module.exports = __webpack_public_path__ + "img/75726.38d09d7e.svg";